import React, { useState } from 'react'
import IndSectionTabs from '../../components/IndSectionTabs'

// ... existing imports ...

const tabData = [
   {
      id: '01ete',
      title: '01. Travel Planning App Development',
      intitle: 'Travel Planning App Development',
      icon: '/assets/svg/industries/travelTourism/01.svg',
      content:
         'We create user-friendly travel planning apps that assist travelers in building itineraries, making flight and hotel bookings, and handling reservations all in one location. Our bespoke travel planning services provide a smooth and interactive experience for travelers. Our apps include interactive itinerary builders with day-by-day planning, real-time weather information, and map integration. We provide multi-device syncing, offline usage, and travel reminders for a convenient experience. With social sharing features, collaborative trip planning, and customized recommendations, we increase user engagement and satisfaction.',
   },
   {
      id: '02ete',
      title: '02. Travel Booking App Development',
      intitle: 'Travel Booking App Development',
      icon: '/assets/svg/industries/travelTourism/02.svg',
      content:
         'Our booking software allows instant booking of flights, hotels, car rentals, and tour packages with secure payment interfaces and simple user interface to make booking easier. We use dynamic pricing techniques, intelligent search filters, and AI-driven suggestions to make booking more efficient. Our offering includes multi-currency support, payment gateway integration, and auto-confirmation emails. With built-in reviews, reward points, and in-app offers, we assist travel companies in increasing conversions and customer loyalty.',
   },
   {
      id: '03ete',
      title: '03. Travel CRM Software Development',
      intitle: 'Travel CRM Software Development',
      icon: '/assets/svg/industries/travelTourism/03.svg',
      content:
         'We create intelligent CRM solutions specific to the travel segment, enabling agencies to handle customer information, likes, bookings, and loyalty programs to improve client relationships and conversions. Our CRM solutions provide lead management automation, customer segmentation, and targeted marketing campaigns. We combine real-time booking information, payment history, and feedback tracking for complete customer insights. Through multi-channel communication, automated reminders, and deep analytics, our solutions maximize customer relationship management and sales performance.',
   },
   {
      id: '04ete',
      title: '04. Travel Management Software Development',
      intitle: 'Travel Management Software Development',
      icon: '/assets/svg/industries/travelTourism/04.svg',
      content:
         'Our travel management solutions help businesses automate bookings, expense tracking, compliance management, and reporting, making corporate travel smooth and efficient. We develop platforms with real-time travel approvals, automated expense categorization, and policy compliance checks. Our solutions are travel provider booking integrations, mileage tracking, and automated invoicing. Businesses can automate travel operations and lower expenses with in-depth expense reports, budget insights, and audit trails.',
   },
   {
      id: '05ete',
      title: '05. Travel Check-in and Boarding Software Development',
      intitle: 'Travel Check-in and Boarding Software Development',
      icon: '/assets/svg/industries/travelTourism/05.svg',
      content:
         'We create self-service check-in and boarding solutions that are integrated with airline and hotel systems, providing QR code-based check-ins, e-boarding passes, and automated customer authentication for a hassle-free travel experience. Our software provides mobile and kiosk check-ins with real-time flight status updates and seat selection. We implement biometric authentication, ID verification, and automated boarding announcements to reduce wait times. With multi-language support and seamless API integrations, we enhance the overall check-in and boarding process.',
   },
   {
      id: '06ete',
      title: '06. GDS API Integration',
      intitle: 'GDS API Integration',
      icon: '/assets/svg/industries/travelTourism/06.svg',
      content:
         'We specialize in integrating Global Distribution System (GDS) APIs with Amadeus, Travelport, and Sabre to enable access to extensive inventories of hotels, flights, and holiday packages on one platform. Integrations with our company provide real-time availability, fare comparison, and management of bookings. We ensure smooth synchronization of travel data with third-party sites, making it possible for travel agencies to provide complete packages. With dynamic pricing, multi-currency support, and automated book workflows, our GDS solutions optimize efficiency and revenue potential.',
   },
];

function IndSectionTwo() {
   return (
      <section className="section_secondary_bg">
         <div className="container">
            <h2 className="text-center tech_title section_heading_title mb-2">
               Comprehensive Travel & Tourism Software Development Services
            </h2>
            <p className="section_desc end-to-end-section mb-xl-0 mb-4">
               Being a top travel software development firm, we provide personalized, scalable, and feature-rich solutions that enrich travel experiences and streamline business processes. Our experience guarantees smooth integration of cutting-edge technologies for the travel and tourism sector. Find out our range of bespoke travel software development services:
            </p>
            <IndSectionTabs tabData={tabData} />
         </div>
      </section>
   )
}

export default IndSectionTwo
